import { handleActions } from "redux-actions";
import * as types from "./constants";

// Reducers below MUST return new state objects. Mutating `state` and returning
// the same reference makes react-redux (v8+, useSyncExternalStore) skip the
// subscriber update, so `isLoading` and `user` stop propagating to components.
export const UserState = {
  isLoading: false,
  user: {},
};

export default handleActions(
  {
    [types.LOGIN]: (state, action) => ({
      ...state,
      user: action.payload.user,
    }),

    [types.REGISTER]: (state, action) => ({
      ...state,
      user: action.payload.user,
    }),

    [types.LOGOUT]: (state, action) => ({
      ...state,
      user: action.payload,
    }),

    [types.LOAD_USER]: (state, action) => ({
      ...state,
      user: action.payload,
    }),

    [types.UPDATE]: (state, action) => ({
      ...state,
      user: action.payload,
    }),

    [types.LOADING_STATUS]: (state, action) => ({
      ...state,
      isLoading: action.payload,
    }),
  },
  UserState
);
